import classNames from "classnames"
import NextImage from "../../elements/image"
import Video from "../../elements/video"
import CustomLink from "../../elements/custom-link"

const FeatureRowsGroup = ({ data }) => {
  return (
    <section className="container py-12 sm:py-16">
      <div className="relative overflow-hidden rounded-3xl border border-[#e0b15e]/30 bg-white/45 shadow-sm backdrop-blur">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(244,188,107,0.22),transparent_60%)]" />
        <div className="relative flex flex-col gap-10 px-6 py-10 sm:px-10 sm:py-12">
      {data.features.map((feature, index) => (
        <div
          className={classNames(
            // Common classes
            "flex flex-col gap-8 lg:gap-12 md:items-center",
            {
              "lg:flex-row": index % 2 === 0,
              "lg:flex-row-reverse": index % 2 === 1,
            }
          )}
          key={feature.id}
        >
          {/* Text section */}
          <div className="w-full lg:w-7/12 lg:pr-8 text-center lg:text-left">
            <div className="title text-balance text-2xl font-extrabold tracking-tight text-[#3f2415] sm:text-3xl">
              {feature.title}
            </div>
            <p className="mx-auto lg:mx-0 mt-4 max-w-2xl text-pretty text-base leading-relaxed text-[#603026] sm:text-lg">
              {feature.description}
            </p>
            <CustomLink link={feature.link}>
              <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-[#e0b15e]/35 
                                  bg-white/60 px-4 py-2 text-sm font-bold text-[#da3334] shadow-sm transition 
                                  hover:bg-white hover:brightness-105 focus:outline-none focus-visible:ring-2 
                                  focus-visible:ring-[#da3334]/30">
                                  
                {feature.link.text}
              </div>
            </CustomLink>
          </div>
          {/* Media section */}
          <div className="w-full sm:w-9/12 lg:w-5/12">
            {/* Images */}
            {feature.media.data.attributes.mime.startsWith("image") && (
              <div className="overflow-hidden rounded-3xl bg-white/35 shadow-sm ring-1 ring-black/5">
                <NextImage media={feature.media} className="h-auto w-full object-cover" />
               </div>
            )}
            {/* Videos */}
            {feature.media.data.attributes.mime.startsWith("video") && (
              <Video
                media={feature.media}
                className="h-auto w-full overflow-hidden rounded-3xl shadow-sm ring-1 ring-black/5"
                 autoPlay
                controls={false}
              />
            )}
          </div>
        </div>
      ))}
      </div>
    </div>
    </section>
  )
}

export default FeatureRowsGroup